import styled from 'styled-components';

const Sender = styled.div`
  flex-direction: row-reverse;
  .avatar {
    position: absolute;
    top: -16px;
  }
  .bubble {
    border-top-right-radius: 0;
    margin-right: 42px;
  }
  .Polaris-Avatar {
    background: linear-gradient(180deg, #88f0ff 0%, #75a6ff 97.04%);
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 600;
  }
`;

const Receiver = styled.div`
  .avatar {
    margin-right: 10px;
    position: absolute;
    top: -16px;
  }
  .bubble {
    border-top-left-radius: 0;
    margin-left: 42px;
  }
  .Polaris-Avatar {
    background: linear-gradient(180deg, #88f0ff 0%, #75a6ff 97.04%);
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 600;
  }
`;

export { Sender, Receiver };
